import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";


import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";

import mech1 from "assets/img/mech1.jpg";
import mech2 from "assets/img/mech2.jpg";
import mech3 from "assets/img/mech3.jpg";
import ece1 from "assets/img/ece1.jpg";
import ece3 from "assets/img/ece3.jpg";

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
              <div>
                    <img
                      src={mech1}
                      alt="Mech"
                      className="slick-image"
                    />

                   <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Carpark MV System
                      </h4>
                    </div>
                  </div>
                 <div>
                    <img
                      src={mech2}
                      alt="Mech"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Domestic Water Tank and Pumps Installation
                      </h4>
                    </div>
                  
                  
                  </div>
                  <div>
                    <img
                      src={mech3}
                      alt="Mech"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Breeching Inlets and 
Sprinkler Control Valve
                      </h4>
                    </div>
                  </div>
                  
                    <div>
                    <img
                      src={ece1}
                      alt="Mech"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Car Parking  Barrier System
                      </h4>
                    </div>
                  </div>
                  
                    <div>
                    <img
                      src={ece3}
                      alt="Mech"
                      className="slick-image"
                    />
                     <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Two Way EVC Panel
                      </h4>
                    </div>
                  </div>
                  
                  
                  

                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/MechPage/Sections/SectionCarousel.jsx